module.exports = __webpack_public_path__ + "assets/b91.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b91.png
// module id = 684
// module chunks = 0